import React, { useState, useEffect } from "react";
import calc from "../../utils/calculation";

import lbl from "../../data/Labels.json";

const FinanceSummaryCard = ({ data, activeYear }) => {
  const [state, setState] = useState({
    payable: 0,
    paid: 0,
    balance: 0,
  });

  useEffect(() => {
    if (data.data) {
      const fPayables = data?.data[0]?.payables.filter(
        (p) => p.half_year_id === (activeYear.half_year_id || activeYear)
      );

      const fPayments = data?.data[0]?.payments.filter(
        (p) => p.half_year_id === (activeYear.half_year_id || activeYear)
      );

      let payable = calc.getTotal(fPayables, "amount");
      let paid = calc.getTotal(fPayments, "amount");
      let balance = (payable - paid).toFixed(2);

      let _obj = {
        payable,
        paid,
        balance,
      };

      setState(_obj);
    }
  }, [activeYear]);

  return (
    <div className="summary-card flex">
      <div className="card-wrapper">
        <p className="summary-title">{"خلاصه عمومی"}</p>
        <ul>
          <li>
            <b>{data?.summary?.opening_balance || 0}</b>
            <span>{lbl.OpeningBalance}</span>
          </li>
          <li>
            <b>{data?.summary?.total_payable || 0}</b>
            <span>{lbl.Payable}</span>
          </li>

          <li>
            <b>{data?.summary?.total_paid || 0}</b>
            <span>{lbl.Paid}</span>
          </li>
        </ul>
      </div>
      <div className="card-wrapper">
        <p className="summary-title">{"خلاصه نیم سال"}</p>
        <ul>
          <li>
            <b>{state.payable || 0}</b>
            <span>{lbl.Payable}</span>
          </li>
          <li>
            <b>{state.paid || 0}</b>
            <span>{lbl.Paid}</span>
          </li>

          <li>
            <b>{state.balance || 0}</b>
            <span>{lbl.Balance}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default FinanceSummaryCard;
